import React, { FC, useState } from 'react';
import Badge from '../badge/badge';
import arrowIcon from '../../images/Home Dropdown.svg';
import gearIcon from '../../images/Gear.svg';
import { generateFieldId } from '../../utilities/GenerateFieldId';
import { useGlobalState } from '@/Providers';

const style = { minWidth: 139, maxHeight: 40 };

export const FlatTab = ({ label, badge, selected, onClick }) => {
    const { buildInfo } = useGlobalState() ?? {};
    const showTabCounts = buildInfo?.showTabCounts;
    
    return (
        <div id={generateFieldId(label, 'TabRoot')}
            className={`flex flex-row justify-center items-baseline bg-white mx-1 cursor-pointer ${selected ? 'font-bold border-b-8 border-portal-blue-primary-shade2' : ''}`}
            onClick={onClick}
            style={style}>
            <p className={`px-3 py-2 text-sm text-center`} id={generateFieldId(label, 'TabRootButton')}>
                {label}
                {badge && showTabCounts
                    ? <Badge className="ml-2">{badge}</Badge>
                    : null
                }
            </p>
        </div>
    );
}

interface TabProps {
    label: string,
    badge: any,
    selected: boolean,
    onClick: (value) => void,
    onEdit?: () => void,
}

const Tab: FC<TabProps> = ({ label, badge, selected, onClick, onEdit = undefined }) => {
    const [onHover, setOnHover] = useState(false);
    const { buildInfo } = useGlobalState() ?? {};
    const showTabCounts = window.sessionStorage.getItem("showTabCounts") === "1";

    const padForEditIcon = (selected, label, badge) => {
        const applyPadding = badge
            ? label.length + `${badge}`.length > 9
            : label.length > 13;
        return selected && applyPadding ? 'mr-5' : ''
    }
    
    return (
        <div id={generateFieldId(label, 'TabRoot')}
            className={`flex flex-none justify-evenly items-baseline bg-${selected ? 'white' : 'gray-deselect'} border-${selected ? 'white' : 'gray-deselect'} rounded-t-lg mx-1 cursor-pointer relative`}
            onClick={onClick}
            style={style}    >
            <p className={`px-3 pt-2 text-sm text-center ${padForEditIcon(selected, label, badge)}`} id={generateFieldId(label, 'TabRootButton')}>
                {label}
                {badge !== undefined && badge !== null && badge != 0 && showTabCounts && (
                    <Badge className="ml-2">{badge}</Badge>
                )}
            </p>
            {selected && onEdit
                ? <img src={gearIcon}
                    alt=''
                    className={`absolute right-0 mt-1 mr-1`}
                    onMouseEnter={() => setOnHover(true)}
                    onMouseLeave={() => setOnHover(false)}
                    style={onHover ? { boxShadow: '1px 1px 2px 1px gray' } : {}}
                    onClick={onEdit}/>
                : null}
        </div>
    );
}

export const TabList = ({ label, badge, selected, onClick, children }) => {
    const { buildInfo } = useGlobalState() ?? {};
    const showTabCounts = window.sessionStorage.getItem("showTabCounts") === "1";

    return (<>
        <div
            className={`flex flex-row h-full pb-1 justify-center items-baseline bg-${selected ? 'white bg-opacity-50' : 'gray-deselect'} border-${selected ? 'white bg-opacity-50' : 'gray-deselect'} rounded-t-lg mx-1 cursor-pointer`}
            onClick={onClick}
            style={style}    >
            <p className="px-3 pt-2 text-sm text-center">
                {label}
                {badge && showTabCounts
                    ? <Badge className="ml-2">{badge}</Badge>
                    : null
                }
            </p>
            <div>
                {selected
                    ?
                    <img className="select-field--arrow align-baseline rotate-icon w-3" src={arrowIcon} alt=""></img>
                    :
                    <img className="select-field--arrow align-baseline w-3" src={arrowIcon} alt=""></img>
                }
            </div>
        </div>
        {children}
    </>
    );
}

export default Tab;
